import { ACCOUNT_PURGE_DAYS, ANON_EXPIRY_DAYS, CIRCLE_TIERS, GATEKEEPER_TIERS, INVITE_TTL_DAYS, MESSAGE_TEXT_TTL_DAYS, PLACE_TIERS, PLUS_EARN_INVITES, PLUS_EARN_VETS, VET_GESTURE_COUNT, } from './constants.js';
import { JOB_PARAM } from './jobs.js';
import { MEET_DISPUTE_HOURS, MEET_NOT_ARRIVED_MIN, MEET_NOT_LEFT_MIN, MEET_PAUSE_AFTER, MEET_PAUSE_DAYS, MEET_PROPOSAL_NOW_MIN, } from './meet-rules.js';
/**
 * The numbers a Learn article may quote as {{NAME}} (content/learn/*.md). The build writes the default
 * in; the page swaps in the live value (GET /v1/learn/values) where the owner can change it in
 * console › Jobs, so an article never states a number the app no longer uses.
 */
export const LEARN_VALUES = {
    ANON_EXPIRY_DAYS: { default: ANON_EXPIRY_DAYS, setting: JOB_PARAM.anonExpiryDays },
    INVITE_TTL_DAYS: { default: INVITE_TTL_DAYS, setting: JOB_PARAM.inviteTtlDays },
    MESSAGE_TEXT_TTL_DAYS: { default: MESSAGE_TEXT_TTL_DAYS, setting: JOB_PARAM.messageTextDays },
    ACCOUNT_PURGE_DAYS: { default: ACCOUNT_PURGE_DAYS, setting: JOB_PARAM.accountPurgeDays },
    VET_GESTURE_COUNT: { default: VET_GESTURE_COUNT },
    // Decisions 64 and 65: the monthly goal (console Regions › Everywhere) and the badge levels.
    PLUS_EARN_VETS: { default: PLUS_EARN_VETS, setting: 'plus.earn_vets' },
    PLUS_EARN_INVITES: { default: PLUS_EARN_INVITES, setting: 'plus.earn_invites' },
    GATEKEEPER_I: { default: GATEKEEPER_TIERS[0] },
    GATEKEEPER_II: { default: GATEKEEPER_TIERS[1] },
    GATEKEEPER_III: { default: GATEKEEPER_TIERS[2] },
    CIRCLE_I: { default: CIRCLE_TIERS[0] },
    CIRCLE_II: { default: CIRCLE_TIERS[1] },
    CIRCLE_III: { default: CIRCLE_TIERS[2] },
    PLACE_I: { default: PLACE_TIERS[0] },
    PLACE_II: { default: PLACE_TIERS[1] },
    PLACE_III: { default: PLACE_TIERS[2] },
    // Meet (decision 163): the owner's numbers on Community › Meet.
    MEET_PROPOSAL_NOW_MIN: { default: MEET_PROPOSAL_NOW_MIN, setting: 'meet.proposal_now_min' },
    MEET_NOT_LEFT_MIN: { default: MEET_NOT_LEFT_MIN, setting: 'meet.not_left_min' },
    MEET_NOT_ARRIVED_MIN: { default: MEET_NOT_ARRIVED_MIN, setting: 'meet.not_arrived_min' },
    MEET_PAUSE_AFTER: { default: MEET_PAUSE_AFTER, setting: 'meet.pause_after' },
    MEET_PAUSE_DAYS: { default: MEET_PAUSE_DAYS, setting: 'meet.pause_days' },
    MEET_DISPUTE_HOURS: { default: MEET_DISPUTE_HOURS, setting: 'meet.dispute_hours' },
};
/**
 * The articles the app links to by name (beside a spot's stats, a map banner, the rules). The web
 * build fails if one is missing, so renaming an article's file can't quietly break a link here.
 */
export const LEARN_SLUG = {
    cruisingBasics: 'cruising-basics',
    silhouettes: 'app-anonymous',
    howReportsWork: 'safety-reports',
    consent: 'safety-consent',
    theChain: 'app-the-chain',
    buildingTheNetwork: 'app-invites',
    howEventsWork: 'app-events',
    howGroupsWork: 'app-groups',
};
/**
 * Articles that moved when every slug took its section's prefix (cruising-, safety-, app-, data-),
 * old to new: the server answers the old address with a 301 (plugins/site.ts) and the app redirects
 * (router.tsx), so a shared link or a published Terms page keeps working.
 */
export const LEARN_MOVED = {
    'what-cruising-looks-like': 'cruising-what-it-looks-like',
    'a-simple-guide-to-cruising': 'cruising-guide',
    'make-cruising-popular-anywhere': 'cruising-anywhere',
    'meeting-up': 'safety-meeting-up',
    consent: 'safety-consent',
    'sexual-health': 'safety-sexual-health',
    party: 'safety-party',
    scams: 'safety-scams',
    'if-something-happened': 'safety-if-something-happened',
    'how-reports-work': 'safety-reports',
    silhouettes: 'app-anonymous',
    'getting-in': 'app-getting-in',
    'the-chain': 'app-the-chain',
    'building-the-network': 'app-invites',
    'consumer-health-data': 'data-health',
};
//# sourceMappingURL=learn.js.map